export enum ReportDocumentFormat {
	Excel = 'Excel',
	Pdf = 'Pdf',
}

export type ReportDocumentFormatType = keyof typeof ReportDocumentFormat;
